import _ from 'lodash'
import React from 'react'

import combineClassNames from '../../helpers/combineClassNames';
import Modal from '../modal'
import Link from '../link'
import Button from '../button';
import IconInfo from '../../assets/icons/icon_info.svg'
import IconCross from '../../assets/icons/icon_cross.svg'

import useStyles from './modal-dialog-style'

const ModalDialog = (props = {}) => {
  const {
    isOpen,
    title,
    enableCloseButton,
    infoButton,
    message,
    html,
    contentComponent,
    buttons,
    className,
    overlayClassName,
    bodyClassName,
    onRequestClose,
    ...others
  } = props
  const styles = useStyles()

  const topButtons = [
    infoButton && 'info',
    enableCloseButton && 'close',
  ]
  return (
    <Modal
      dialog
      className={combineClassNames([styles.dialogModal, className])}
      overlayClassName={combineClassNames([styles.dialogModalOverlay, overlayClassName])}
      titleClassName={styles.dialogTitle}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={title}
      {...others}
    >
      {
        !_.isEmpty(topButtons) && (
          <div className={styles.dialogTopButtons}>
            {
              _.map(topButtons, (button, index) => {
                switch (button) {
                  case 'info':
                    return (
                      <Link
                        key={`modal_info_button_${index}`}
                        gatsbyLink
                        className={styles.dialogInfoButton}
                        {...infoButton}
                      >
                        <img src={IconInfo} alt="info" className={styles.dialogInfoButtonImage} />
                      </Link>
                    )
                  case 'close':
                    return (
                      <Button
                        className={styles.closeButton}
                        inline
                        onClick={onRequestClose}
                        iconImage={IconCross}
                        iconClassName={styles.closeButtonIcon}
                      />
                    )
                  default:
                    return null
                }
              })
            }
          </div>
        )
      }
      <div className={styles.dialogContainer}>
        <div className={combineClassNames([styles.dialogBody, bodyClassName])}>
          {
            !_.isEmpty(message) && (
              <p className={styles.dialogDescription}>{message}</p>
            )
          }
          {
            !_.isEmpty(html) && (
              <div
                className={styles.dialogHtml}
                dangerouslySetInnerHTML={{ __html: html }}
              />
            )
          }
          {contentComponent}
          {props.children}
        </div>
        {
          !_.isEmpty(buttons) && (
            <div className={styles.dialogFooter}>
              <div className={styles.dialogButtons}>
                {
                  _.map(buttons, (button, index) => (
                    <Button
                      key={`modal_button_${index}`}
                      className={styles.button}
                      dark={index === 0}
                      border={index !== 0}
                      {...button}
                    />
                  ))
                }
              </div>
            </div>
          )
        }
      </div>
    </Modal>
  )
}

export default ModalDialog
